import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from '@hooks/useTranslation';
import { useIsFollowing } from '@hooks/TRPC_Hooks/useIsFollowing';
import { useProfile } from '@hooks/TRPC_Hooks/useProfile';
import { useFollow } from '@hooks/TRPC_Hooks/useFollow';
import { useUnfollow } from '@hooks/TRPC_Hooks/useUnfollow';
import { Button, ButtonProps } from '../UIKit/Button/Button';
import { LinksEnum } from '@specs/navigation';
import { useSession } from 'next-auth/react';
interface FollowButtonProps {
  buttonProps: Omit<ButtonProps, 'children' | 'loading' | 'disabled' | 'onClick' | 'id'>;
  shortid: string;
  blocked?: boolean;
}
export const FollowButton: FC<FollowButtonProps> = ({
  shortid,
  buttonProps,
  blocked = false
}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const {
    status
  } = useSession();
  const {
    data: profile,
    isLoading: profileLoading
  } = useProfile();
  const {
    data: isFollowing,
    isLoading: isFollowingLoading
  } = useIsFollowing({
    shortid
  });
  const {
    mutateAsync: followMutate
  } = useFollow();
  const {
    mutateAsync: unfollowMutate
  } = useUnfollow();
  const isLoading = profileLoading || isFollowingLoading;
  const SHOW_SETTINGS = profile?.shortid === shortid;
  const clickHandler = async () => {
    if (isLoading) return;
    if (SHOW_SETTINGS) return await router.push(LinksEnum.SETTINGS);
    isFollowing ? await unfollowMutate({
      shortid
    }) : await followMutate({
      shortid
    });
  };
  return <Button {...buttonProps} onClick={clickHandler} loading={isLoading && status === 'authenticated'} disabled={blocked || status !== 'authenticated'} color={isFollowing ? 'White' : 'Black'} id={blocked || SHOW_SETTINGS ? 'default_button' : isFollowing ? 'unfollow_button' : 'follow_button'} data-sentry-element="Button" data-sentry-component="FollowButton" data-sentry-source-file="FollowButton.tsx">
            {SHOW_SETTINGS ? tr({
      id: 'btn.edit.profile'
    }) : blocked ? tr({
      id: 'public.profile.followed'
    }) : isFollowing ? tr({
      id: 'btn.unfollow'
    }) : tr({
      id: 'btn.follow'
    })}
        </Button>;
};